import { clearAdminSession, getAdminToken } from "./adminAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_ADMIN_API_BASE_URL ||
  "http://secondbite-manage.localhost/admin-api/v1"
).replace(/\/+$/, "");

const request = async (path, options = {}) => {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getAdminToken()}`,
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...options.headers,
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }
  const payload = await response.json().catch(() => null);
  if (response.status === 401) {
    clearAdminSession();
    window.location.replace("/login");
    throw new Error("Your session has expired.");
  }
  if (!response.ok || !payload?.success) {
    const validationMessage = payload?.errors
      ? Object.values(payload.errors).flat().find(Boolean)
      : null;
    throw new Error(validationMessage || payload?.message || "Request failed.");
  }
  return payload;
};

const statusValues = { Active: "1", Inactive: "0", "Pending Setup": "2" };

export const listAdminMerchants = async ({ status = "", keyword = "" } = {}) => {
  const params = new URLSearchParams({ per_page: "100" });
  if (statusValues[status] !== undefined) params.set("status", statusValues[status]);
  if (keyword.trim()) params.set("keyword", keyword.trim());
  return (await request(`/merchants?${params}`)).data;
};

export const getAdminMerchant = async (id) =>
  (await request(`/merchants/${id}`)).data;

export const createAdminMerchant = async (data) =>
  (await request("/merchants", { method: "POST", body: JSON.stringify(data) })).data;

export const updateAdminMerchant = async (id, data) =>
  (await request(`/merchants/${id}`, { method: "PUT", body: JSON.stringify(data) })).data;

export const updateAdminMerchantStatus = async (id, status) =>
  (await request(`/merchants/${id}/status`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  })).data;
